module.exports = __webpack_public_path__ + "img/CheckboxIcon.508f9aa5.png";